import * as React from 'react';

import type { WithUIStateProps } from './withUIState';

/**
 * This is just a placeholder for context value which will be assigned within provider component
 */
const defaultValue: WithUIStateProps = {
  setUIState: () => false,
};

export const context = React.createContext(defaultValue);

export const { Provider, Consumer } = context;
